import { loginUser, signUpUser, logoutUser } from '@/services/api/auth';
import { getUserProfile } from '@/services/api/users';
import { deletePaymentMethod } from '@/services/api/payments';

// initial state
const state = () => ({
  token: localStorage.getItem('access_token'),
  signUpSuccessful: false,
  signUpEmail: '',
  user: null
})

// getters
const getters = {
  isAuthenticated: state => !!state.token,
}

// mutations
const mutations = {
  loginSuccess(state, token) {
    state.token = token;
  },
  signUpSuccess(state, email) {
    state.signUpSuccessful = true
    state.signUpEmail = email
  },
  logout(state) {
    state.token = null;
  },
  setUser(state, user) {
    state.user = user
  },
  REMOVE_PAYMENT_METHOD(state, paymentMethodId) {
    state.user.djstripeCustomers[0].paymentMethods = state.user.djstripeCustomers[0].paymentMethods.filter(
      (paymentMethod) => paymentMethod.id != paymentMethodId
    );
  }
}

// actions
const actions = {
  login({ commit }, { username, password }) {
    return loginUser(username, password)
      .then(resp => {
        commit('loginSuccess', resp.access)
        return Promise.resolve();
      })
      .catch(err => {
        return Promise.reject(err);
      })
  },
  signUp({ commit }, { username, password, firstName, lastName }) {
    return signUpUser(username, password, firstName, lastName)
      .then(resp => {
        commit('signUpSuccess', resp.email)
        return Promise.resolve();
      })
      .catch(err => {
        return Promise.reject(err);
      })
  },
  logout({ commit }) {
    logoutUser();
    commit('logout')
  },
  getProfile({ commit }) {
    return getUserProfile()
      .then(resp => {
        commit('setUser', resp)
        return Promise.resolve();
      })
      .catch(err => {
        logoutUser();
        commit('logout');
        return Promise.reject(err);
      })
  },
  removePaymentMethod({ commit }, paymentMethodId) {
    return deletePaymentMethod(paymentMethodId)
    .then((resp) => {
      commit('REMOVE_PAYMENT_METHOD', paymentMethodId)
      return Promise.resolve(resp);
    })
    .catch(err => {
      return Promise.reject(err);
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}